import Bacon from "Bacon";
import $ from "jquery";
import error from "error";
import login from "login";

function stream(options, errorHandler) {
  var ajaxStream = Bacon.fromPromise($.ajax(options));

  login.unauthorized(ajaxStream);
  if (typeof errorHandler === "undefined") {
    errorHandler = error.handler;
  }
  ajaxStream.onError(errorHandler);
  return ajaxStream;
}

function ajaxify($target) {
  return stream({
    url: $target.attr('action'),
    data: $target.serialize(),
    type: $target.attr('method'),
    dataType: $target.attr('data-type') ? $target.attr('data-type') : "json"
  });
}

export default {
  stream: stream,
  ajaxify: ajaxify,
  emptyErrorHandler: function () {
  }
};



// WEBPACK FOOTER //
// ./web/js/ajax.js